<template>
  <el-form :model="form" :rules="rules"></el-form>
</template>

<script>
import { getRevenueNewList } from '@/api/enterprise'

export default {
  props: ['ans', 'cb', 'userId'],
  data () {
    return {
      form: {},
      rules: {}
    }
  },
  mounted () {
    if (this.ans.version) {
      const [personRevenue2021, personRevenue2022, personRevenue2023] = this.ans.revenue
      const [digit2021, digit2022, digit2023] = this.ans.digitInput
      const x1 = (personRevenue2021 * 1 || 0) === 0 ? 0 : (digit2021 / personRevenue2021 || 0)
      const x2 = (personRevenue2022 * 1 || 0) === 0 ? 0 : (digit2022 / personRevenue2022 || 0)
      const x3 = (personRevenue2023 * 1 || 0) === 0 ? 0 : (digit2023 / personRevenue2023 || 0)
      const result = ((x1 + x2 + x3) / 3 * 100).toFixed(3)
      const data = Object.assign({ result, x1, x2, x3 }, this.ans)
      this.form = { result: data.result, version: this.ans.version, year: this.ans.year, digitInput: this.ans.digitInput, revenue: this.ans.revenue, x1: data.x1, x2: data.x2, x3: data.x3 }
    } else if (this.ans.digitInput && this.ans.revenue) {
      const [personRevenue2021, personRevenue2022, personRevenue2023] = this.ans.revenue
      const [digit2021, digit2022, digit2023] = this.ans.digitInput
      const x1 = (personRevenue2021 * 1 || 0) === 0 ? 0 : (digit2021 / personRevenue2021 || 0)
      const x2 = (personRevenue2022 * 1 || 0) === 0 ? 0 : (digit2022 / personRevenue2022 || 0)
      const x3 = (personRevenue2023 * 1 || 0) === 0 ? 0 : (digit2023 / personRevenue2023 || 0)
      const result = ((x1 + x2 + x3) / 3 * 100).toFixed(3)
      const data = Object.assign({ result, x1, x2, x3 }, this.ans)
      this.form = { result: data.result, digitInput: this.ans.digitInput, revenue: this.ans.revenue, x1: data.x1, x2: data.x2, x3: data.x3 }
    } else {
      this.loadYear()
    }
  },
  methods: {
    loadYear () {
      getRevenueNewList(this.userId).then(res => {
        const revenue = res.data.sort((a, b) => a.year * 1 > b.year * 1 ? 1 : -1)
        const { personRevenue: personRevenue2023, digitInput: digit2023, year: year2023 } = revenue[2]
        const { personRevenue: personRevenue2022, digitInput: digit2022, year: year2022 } = revenue[1]
        const { personRevenue: personRevenue2021, digitInput: digit2021, year: year2021 } = revenue[0]
        const x1 = (personRevenue2021 * 1 || 0) === 0 ? 0 : (digit2021 / personRevenue2021 || 0)
        const x2 = (personRevenue2022 * 1 || 0) === 0 ? 0 : (digit2022 / personRevenue2022 || 0)
        const x3 = (personRevenue2023 * 1 || 0) === 0 ? 0 : (digit2023 / personRevenue2023 || 0)
        const result = ((x1 + x2 + x3) / 3 * 100).toFixed(3)
        this.form = { result, x1, x2, x3, version: 1, year: [year2021, year2022, year2023], digitInput: [digit2021, digit2022, digit2023], revenue: [personRevenue2021, personRevenue2022, personRevenue2023] }
        this.cb(this.form, year2023)
      })
    }
  }
}
</script>
